import { yieldToMain } from 'assets/core/js/common'
import budgetSlider from 'assets/core/js/page/search/budgetSlider'
import submitFilterForm from './submitFilterForm'

export default function (): void {
  void (async () => {
    await yieldToMain()
    budgetSlider({ callbackChange: submitFilterForm })
  })()
}
